import { render } from "./Sidebar.vue?vue&type=template&id=438ae696&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=438ae696&lang=scss"
import "./Sidebar.vue?vue&type=style&index=1&id=438ae696&lang=scss&scoped=true"

import exportComponent from "/home/admin/swarm-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438ae696"]])

export default __exports__